import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth';

/**
 * Custom hook to validate authentication token
 * Redirects to login if token is invalid or expired
 */
export const useAuthValidation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isValid = authService.validateToken();
    
    if (!isValid) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);
};
